import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import Navigation from "./Navigation";
import "../../styles/Header.css";
import ecoFarmLogo from "../../assets/images/logo1.png";
import royalBrinkmanLogo from "../../assets/images/logo2.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isFixed, setIsFixed] = useState(false);

  // const { language, changeLanguage } = useLanguage();
  // const location = useLocation();
  const { language } = useLanguage();

  useEffect(() => {
    if (window.innerWidth <= 992) {
      if (isMenuOpen) {
        document.body.style.overflow = "hidden";
        setIsFixed(true);
      } else {
        document.body.style.overflow = "hidden";
        setIsFixed(false);
      }
    }
    return () => {
      document.body.style.overflow = "hidden";
      setIsFixed(false);
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // 현재 경로에 맞는 홈 링크 생성
  const homeLink = language === "en" ? "/en/" : "/";

  // 헤더 클래스에 고정 상태 추가
  const headerClass = `header ${isFixed ? "fixed-header" : ""}`;

  return (
    <header className={headerClass}>
      <div className="container">
        <div className="logo-section">
          <Link to={homeLink}>
            <div className="logo ecofarm-logo">
              <img src={ecoFarmLogo} alt="ECOTECH GLOBAL" />
            </div>
          </Link>
          <Link to={homeLink}>
            <div className="logo royal-brinkman-logo">
              <img src={royalBrinkmanLogo} alt="Royal Brinkman" />
            </div>
          </Link>
        </div>
        <button className="mobile-menu-button" onClick={toggleMenu} aria-label="메뉴 열기">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="28" viewBox="0 0 42.001 30.423">
            <g data-name="그룹 106">
              <g data-name="그룹 105">
                <path data-name="선 80" transform="translate(1 1)" style={{ fill: "none", stroke: "#3b3b3b", strokeLinecap: "round", strokeWidth: "2px" }} d="M0 0h40.001" />
                <path data-name="선 81" transform="translate(1 15.211)" style={{ fill: "none", stroke: "#3b3b3b", strokeLinecap: "round", strokeWidth: "2px" }} d="M0 0h40.001" />
                <path data-name="선 82" transform="translate(1 29.423)" style={{ fill: "none", stroke: "#3b3b3b", strokeLinecap: "round", strokeWidth: "2px" }} d="M0 0h40.001" />
              </g>
            </g>
          </svg>
        </button>
        <Navigation isMenuOpen={isMenuOpen} closeMenu={closeMenu} />
      </div>
    </header>
  );
};

export default Header;
